import { CustomInputModule } from './custom-input/custom-input.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomDropdownModule } from './custom-dropdown/custom-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    CustomInputModule,
    CustomDropdownModule
  ],
  exports: [
    CustomDropdownModule,
    CustomInputModule
  ],
  declarations: []
})
export class FormControlsModule { }
